import { CircularProgress } from "@mui/material";

const CircularProgressLoading: React.FC = () => {

  return (
    <div className='loading-holder' tabIndex={0} aria-labelledby='loading-description'>
      <CircularProgress aria-hidden="true" />
    </div>
  );
}

export default CircularProgressLoading;
